import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const CustomPagination = ({ totalPages, curPage, onPageChange }) => {
  
  const handlePageChange = (event, value) => {
    onPageChange(value);
  };

  return (
    <Stack spacing={2}>
      <Pagination
        count={totalPages}
        onChange={handlePageChange}
        page={curPage}
        color="primary"
        shape="rounded"
        sx={{
          '& .MuiPaginationItem-root': {
            color: '#949494',
            borderRadius: '10px', // more rounded
          },
          '& .Mui-selected': {
            backgroundColor: '#F2F2F2 !important',
            color: '#4F63BE !important',
            fontWeight:600,
            borderColor: '#E27DDD',
            borderRadius: '10px', // even more rounded when selected
          },
        }}
      />
    </Stack>
  );
};

export default CustomPagination;
